import SectionHeading from "@/pages/home/components/SectionHeading";
import { categoryCards } from "@/mocks/home";

export default function CategorySection() {
  return (
    <section id="category" className="hl-anchor w-full bg-background-100">
      <div className="px-4 py-14 md:px-6 md:py-16 lg:px-8">
        <SectionHeading
          eyebrow="Channels"
          title="黑料51瓜田 · 分区入口"
          desc="按浏览习惯分好的四条入口，想追热点、想深挖线索、想系统看一个题材，从对应分区进去就行。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {categoryCards.map((card) => (
            <a
              key={card.id}
              href="#hot-rank"
              className="group flex flex-col justify-between rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 md:p-6"
            >
              <div>
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-600 group-hover:text-background-50">
                  <i className={`${card.icon} text-xl`} />
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                  {card.name}
                </h3>
                <p className="mt-2.5 text-xs leading-relaxed text-foreground-600 md:text-sm">
                  {card.desc}
                </p>
              </div>
              <div className="mt-6 flex items-center justify-between border-t border-background-200 pt-4">
                <span className="text-xs font-semibold text-secondary-700">{card.count}</span>
                <span className="flex h-7 w-7 items-center justify-center rounded-full border border-background-300 text-foreground-500 transition-colors group-hover:border-primary-300 group-hover:text-primary-600">
                  <i className="ri-arrow-right-line text-sm" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}